import { InjectionToken, inject } from '@angular/core';
import {
  MinLengthValidationError,
  MaxLengthValidationError,
  MinValidationError,
  MaxValidationError,
} from '@angular/forms/signals';
import type { NttValidationMessagesMap } from '../core';

export type ValidationMessagesMap = NttValidationMessagesMap;

const DEFAULT_VALIDATION_MESSAGES: ValidationMessagesMap = {
  required: () => 'این فیلد الزامی است',
  minLength: (e) =>
    `حداقل ${(e as MinLengthValidationError).minLength} کاراکتر وارد کنید`,
  maxLength: (e) =>
    `حداکثر ${(e as MaxLengthValidationError).maxLength} کاراکتر مجاز است`,
  min: (e) => `حداقل مقدار ${(e as MinValidationError).min} است`,
  max: (e) => `حداکثر مقدار ${(e as MaxValidationError).max} است`,
  email: () => 'ایمیل معتبر نیست',
  pattern: () => 'فرمت کارت بانکی وارد شده صحیح نمی باشد.',
};

export const NTT_VALIDATION_MESSAGES =
  new InjectionToken<ValidationMessagesMap>('NTT_VALIDATION_MESSAGES', {
    providedIn: 'root',
    factory: (): ValidationMessagesMap => {
      const overrides = inject(NTT_VALIDATION_MESSAGES, { optional: true });
      return {
        ...DEFAULT_VALIDATION_MESSAGES,
        ...(overrides || {}),
      };
    },
  });
